import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider } from '@/context/AuthContext'
import { ToastProvider } from '@/context/ToastContext'
import { ToastContainer } from '@/components/ui/ToastContainer'
import { ProtectedRoute } from '@/components/layout/ProtectedRoute'
import { AppShell } from '@/components/layout/AppShell'
import LoginPage from '@/pages/LoginPage'
import TemplatesPage from '@/pages/TemplatesPage'
import DataSourcesPage from '@/pages/DataSourcesPage'
import SnippetsPage from '@/pages/SnippetsPage'
import WebhookSubscriptionsPage from '@/pages/WebhookSubscriptionsPage'
import WebhookDeliveryAttemptsPage from '@/pages/WebhookDeliveryAttemptsPage'
import DesignerPage from '@/pages/DesignerPage'
import ViewerPage from '@/pages/ViewerPage'

export default function App() {
  return (
    <AuthProvider>
      <ToastProvider>
        <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
          <Routes>
            <Route path="/login" element={<LoginPage />} />

            <Route element={<ProtectedRoute />}>
              <Route element={<AppShell />}>
                <Route index element={<Navigate to="/templates" replace />} />
                <Route path="/templates" element={<TemplatesPage />} />
                <Route path="/datasources" element={<DataSourcesPage />} />
                <Route path="/snippets" element={<SnippetsPage />} />
                <Route path="/publish-subscribers" element={<WebhookSubscriptionsPage />} />
                <Route path="/webhook-deliveries" element={<WebhookDeliveryAttemptsPage />} />
                <Route path="/designer" element={<DesignerPage />} />
                <Route path="/designer/:id" element={<DesignerPage />} />
                <Route path="/viewer/:id" element={<ViewerPage />} />
              </Route>
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <ToastContainer />
      </ToastProvider>
    </AuthProvider>
  )
}
